import api from 'utils/api';

export const fetchStatesAPI = () => api.get('/geo/states');
export const fetchCitiesAPI = (data) =>
	api.get('/geo/cities', { params: data });
export const fetchZipcodesAPI = (data) =>
	api.get('/geo/zipcode', { params: data });
